import { MobXProviderContext } from 'mobx-react';
import React from "react";
import RootStore from './RootStore';

export type GetFromRootStore<TStore> = (x: RootStore) => TStore;

export const useStore = <TStore>(selectStore: GetFromRootStore<TStore>): TStore =>
  selectStore(React.useContext(MobXProviderContext) as RootStore);
